import { makeStyles } from '@mui/styles'
import {
  FinanceCalculatorTheme,
  FcTooltipElementClasses,
} from '@dxp-module/themes'

const tooltipElementStyles = makeStyles<
  FinanceCalculatorTheme,
  object,
  FcTooltipElementClasses
>(
  ({ palette, breakpoints }) => ({
    breakdownSection: {
      color: palette.common.black,
      padding: '0 10px 0 0',
      [breakpoints.down(breakpoints.values.xs)]: {
        paddingRight: 60,
      },
      fontWeight: 400,
      width: '100%',
    },
    breakdownSectionBlack: {
      fontWeight: 400,
      width: '100%',
    },
    breakdownValue: {
      textAlign: 'right',
      paddingRight: 25,
      width: '100%',
    },
    breakdownAlign: {
      paddingRight: 25,
      textAlign: 'right',
    },
    repaymentAmount: {
      fontWeight: 'inherit',
    },
    breakdownTooltip: {
      position: 'absolute',
      top: -3,
      right: 0,
    },
    label: {
      width: '100%',
    },
    highlighted: {},
  }),
  { name: 'FC_TooltipElement' }
)

export default tooltipElementStyles
